import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import type { Locale } from '@/i18n/config';
import type { Currency } from '@/lib/utils/constants';
import { devtoolsConfig } from './secure-storage';

interface ConfigState {
  // Locale
  locale: Locale;

  // Currency
  currency: Currency;

  // Actions
  setLocale: (locale: Locale) => void;
  setCurrency: (currency: Currency) => void;
}

export const useConfigStore = create<ConfigState>()(
  devtools(
    persist(
      (set) => ({
        // Initial state
        locale: 'fr',
        currency: 'EUR',

        // Actions
        setLocale: (locale) => {
          // Set cookie for locale
          document.cookie = `LOCALE=${locale}; path=/; max-age=31536000`;
          set({ locale });
        },

        setCurrency: (currency) => set({ currency }),
      }),
      {
        name: 'config-storage',
      }
    ),
    { ...devtoolsConfig, name: 'config-store' }
  )
);
